module.exports = __webpack_public_path__ + "assets/img/per-38dfe5a4.png";